<div class="filters-container">
  <div class="date-filter-block">
    <mat-form-field>
      <mat-label> A partir de </mat-label>
      <input matInput [matDatepicker]="dateDebutPicker" [(ngModel)]="dateDebut"
        (dateInput)="filterDateDebutSubj.next($event.target.value)"
        (dateChange)="filterDateDebutSubj.next($event.target.value)" readonly>
      <fa-icon *ngIf="dateDebut" matSuffix class="fa-Times" [icon]="faTimes" (click)="clearFilter('dateDebut')">
      </fa-icon>
      <mat-datepicker-toggle matSuffix [for]="dateDebutPicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #dateDebutPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Jusqu'à </mat-label>
      <input matInput [matDatepicker]="dateFinPicker" [(ngModel)]="dateFin"
        (dateInput)="filterDateFinSubj.next($event.target.value)"
        (dateChange)="filterDateFinSubj.next($event.target.value)" readonly>
      <fa-icon *ngIf="dateFin" matSuffix class="fa-Times" [icon]="faTimes" (click)="clearFilter('dateFin')"></fa-icon>
      <mat-datepicker-toggle matSuffix [for]="dateFinPicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #dateFinPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <mat-form-field class="search-field">
    <mat-icon matPrefix class="search-icon">
      <fa-icon [icon]="faSearch"></fa-icon>
    </mat-icon>
    <input matInput type="search" [(ngModel)]="numPiece" placeholder="Rechercher par N° pièce"
      (keyup)="filterNumPieceSubj.next($event.target.value)" />
    <fa-icon *ngIf="numPiece" matSuffix class="fa-Times" [icon]="faTimes" (click)="clearFilter('numPiece')"></fa-icon>
  </mat-form-field>

</div>
